var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserBusiness = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 4a2 2 0 10-4 0 2 2 0 004 0zm1.333 0a3.333 3.333 0 11-6.666 0 3.333 3.333 0 016.666 0zM13.333 14.667a5.333 5.333 0 00-10.666 0 .667.667 0 11-1.334 0 6.667 6.667 0 0113.334 0 .667.667 0 01-1.334 0z",
  fill: "#44494D"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8c.293 0 .551.191.637.47l1.334 4.334c.064.211.02.44-.117.613l-1.333 1.666a.667.667 0 01-1.042 0l-1.333-1.666a.667.667 0 01-.117-.613l1.334-4.333A.667.667 0 018 8zm-.593 4.858L8 13.6l.592-.74L8 10.933l-.593 1.924z",
  fill: "#44494D"
})));
export default __webpack_public_path__ + "static/userBusiness.[git-hash].svg";
export { SvgUserBusiness as ReactComponent };